var map = {
	"./blender.svg": 136,
	"./c++.svg": 137,
	"./c.svg": 138,
	"./chartjs.svg": 139,
	"./css.svg": 140,
	"./figma.svg": 141,
	"./firebase.svg": 142,
	"./git.svg": 143,
	"./gitlab.svg": 144,
	"./html.svg": 145,
	"./java.svg": 146,
	"./javascript.svg": 147,
	"./linux.svg": 148,
	"./mysql.svg": 149,
	"./netlify.svg": 150,
	"./nginx.svg": 151,
	"./nodejs.svg": 152,
	"./photoshop.svg": 153,
	"./php.svg": 154,
	"./postman.svg": 155,
	"./python.svg": 156,
	"./reactjs.svg": 157,
	"./sass.svg": 158,
	"./spring.svg": 159,
	"./symfony.svg": 160,
	"./twig.svg": 161,
	"./unity.svg": 162,
	"./unreal.svg": 163,
	"./vscode.svg": 164,
	"./vuejs.svg": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 565;